/**
 * @generated SignedSource<<04c2f9ccfbe8a0dcc3e179dc3c62b3a3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type topicDescriptionTopic$data = {
  readonly description: {
    readonly json: Schema | null | undefined;
    readonly text: string | null | undefined;
  } | null | undefined;
  readonly mobileImage: {
    readonly alt: string | null | undefined;
    readonly style: {
      readonly url: string | null | undefined;
    } | null | undefined;
    readonly title: string | null | undefined;
  } | null | undefined;
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"entityFollowButtonBase" | "hooksTopic" | "topicHeaderRelatedLinksTopic">;
  readonly " $fragmentType": "topicDescriptionTopic";
};
export type topicDescriptionTopic$key = {
  readonly " $data"?: topicDescriptionTopic$data;
  readonly " $fragmentSpreads": FragmentRefs<"topicDescriptionTopic">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "topicDescriptionTopic",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "topicHeaderRelatedLinksTopic"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "entityFollowButtonBase"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "hooksTopic",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "types",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Sponsor",
          "kind": "LinkedField",
          "name": "sponsor",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__typename",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    },
    {
      "alias": "mobileImage",
      "args": [
        {
          "kind": "Literal",
          "name": "type",
          "value": "MOBILE_APP_IMAGE"
        }
      ],
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "image",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "alt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "filter",
              "value": {
                "style": "300x300"
              }
            }
          ],
          "concreteType": "ImageStyle",
          "kind": "LinkedField",
          "name": "style",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            }
          ],
          "storageKey": "style(filter:{\"style\":\"300x300\"})"
        }
      ],
      "storageKey": "image(type:\"MOBILE_APP_IMAGE\")"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FormattedValue",
      "kind": "LinkedField",
      "name": "description",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "json",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "text",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Topic",
  "abstractKey": null
};

(node as any).hash = "6d46df12009a8bec8aff1a15bfb2bce6";

export default node;
